var SupportBasePresentation, SupportLocalPresenterPresentation, SupportLocalStatusAndNotesPresentation,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBasePresentation = require('./base');

SupportLocalStatusAndNotesPresentation = require('./local_messages');

SupportLocalPresenterPresentation = (function(superClass) {
  extend(SupportLocalPresenterPresentation, superClass);

  function SupportLocalPresenterPresentation() {
    return SupportLocalPresenterPresentation.__super__.constructor.apply(this, arguments);
  }

  SupportLocalPresenterPresentation.prototype.getLookupObject = function() {
    return SupportLocalStatusAndNotesPresentation;
  };

  return SupportLocalPresenterPresentation;

})(SupportBasePresentation);

module.exports = SupportLocalPresenterPresentation;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9sb2NhbF9wcmVzZW50ZXIuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9sb2NhbF9wcmVzZW50ZXIuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsa0dBQUE7RUFBQTs7O0FBQUEsdUJBQUEsR0FBMEIsT0FBQSxDQUFRLFFBQVI7O0FBQzFCLHNDQUFBLEdBQXlDLE9BQUEsQ0FBUSxrQkFBUjs7QUFFbkM7Ozs7Ozs7OENBQ0wsZUFBQSxHQUFpQixTQUFBO1dBQ2hCO0VBRGdCOzs7O0dBRDhCOztBQUloRCxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
